import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DebugService, DebugFlag } from '../../services/debug.service';
import { AuthService } from '../../../auth/auth.service';
import { InstructorOrganizationService } from '../../../instructor/instructor-organization.service';
import { IconComponent } from '../icon/icon.component';

interface DebugToggleItem {
  flag: DebugFlag;
  label: string;
  description: string;
}

@Component({
  selector: 'app-debug-menu',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './debug-menu.component.html',
  styleUrls: ['./debug-menu.component.scss']
})
export class DebugMenuComponent {
  readonly toggles: DebugToggleItem[] = [
    { flag: 'showIds', label: 'Show IDs', description: 'Course, org, user IDs' },
    { flag: 'consoleLogs', label: 'Console Logs', description: 'Enable console.log output' },
    { flag: 'videoInfo', label: 'Video Info', description: 'Video name + bunny ID overlay' },
    { flag: 'quizDebug', label: 'Quiz Debug', description: 'Quiz/question IDs & details' },
    { flag: 'autoFillQuiz', label: 'Auto-fill Quiz', description: 'Auto-fill quiz answers' },
    { flag: 'orgContext', label: 'Org Context', description: 'Current org name + ID' },
    { flag: 'moduleUnitIds', label: 'Module/Unit IDs', description: 'Module and unit IDs' },
  ];

  constructor(
    public debug: DebugService,
    private authService: AuthService,
    private orgService: InstructorOrganizationService
  ) {}

  get currentOrgName(): string {
    const user = this.authService.getCurrentUser();
    return (user as any)?.currentOrgName || (user as any)?.organizationName || 'Unknown';
  }

  get currentOrgId(): string {
    return this.orgService.getSelectedOrganizationId() || 'N/A';
  }

  onMasterToggle(): void {
    this.debug.toggleAll(!this.debug.allEnabled());
  }

  onToggle(flag: DebugFlag): void {
    this.debug.toggle(flag);
  }
}
